import React from 'react';
import $ from 'jquery';
import ContestLanding from '../common/ContestLanding';
import HmEventRegistry from '../../model/HmEventRegistry';
import ComponentRegistry from '../../model/ComponentRegistry';

export default class WeeklyChallengeInstruction extends ContestLanding{
	 constructor(props) {
        super(props);
        this.state = {
        
        };
        this.dashboardDropDownKey = "homeDropdown";
        this.setChild(this,"CONTEST");

    }
    
    componentDidMount(){
        super.componentDidMount();
        HmEventRegistry.fireEvent("INITIATE_GA");
        HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
    }

    render() {
        return super.render(
          <div className="HomeComponent" id="ContestInstruct">
          <h4>Instructions</h4>
            <div className="instruct-content">
            <ul>
                <li>Go to the Contest tab and click on 'Start' under HeyMath! Challenge.</li>
                <li>Click 'Start' in the HeyMath! Challenge dialog box to attempt the question.</li>
                <li>Select an option to indicate your answer. If you click on the selected option again, it will deselect your answer.</li>
                <li>On completing the question, click on the 'SUBMIT TEST' button.</li>                
           </ul>            
            </div>
         </div>
      )
  }
}

ComponentRegistry.register("in_ContestInstruction",WeeklyChallengeInstruction);


// WEBPACK FOOTER //
// ./src/views/contest/WeeklyChallengeInstruction.js